import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { DashboardItemWithSections } from 'domain/shared/core/dashboard';
import { useStaffingDashboardCallbacks } from '../hooks/useStaffingDashboardCallbacks';

interface StaffingDashboardExpandedItemWrapperProps {
  children: React.ReactNode;
  bottomContent?: React.ReactNode;
}

const StaffingDashboardExpandedItemWrapper: React.FC<StaffingDashboardExpandedItemWrapperProps> = ({
  children,
  bottomContent,
}) => {
  const { projectData, menuOptions, handleFollowUpRemove, handleFollowUpUpdate } = useStaffingDashboardCallbacks();

  return (
    <>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid size={{ xs: 4 }}>{children}</Grid>
        <Grid size={{ xs: 8 }}>
          <DashboardItemWithSections
            item={{
              ...projectData,
              id: projectData.id,
            }}
            sectionsConfig={{
              followUps: { enabled: true, maxItems: 20, title: 'Follow-ups' },
              issues: { enabled: true, maxItems: 3, title: 'Issues', showSeverityColors: true },
              people: { enabled: true, title: '', isOpenInNewTab: true },
            }}
            menuOptions={menuOptions}
            onFollowUpRemove={handleFollowUpRemove}
            onFollowUpUpdate={handleFollowUpUpdate}
          />
        </Grid>
      </Grid>
      {bottomContent && (
        <Grid container sx={{ mt: 2 }}>
          <Grid size={{ xs: 12 }}>{bottomContent}</Grid>
        </Grid>
      )}
    </>
  );
};

export default StaffingDashboardExpandedItemWrapper;
